import type { DailyTotal, DailyBreakdown, DeviceBreakdown } from '../types/analytics';

export interface PivotedDailyData {
  date: string;
  [metricName: string]: string | number;
}

export function pivotDailyTotals(dailyTotals: DailyTotal[]): PivotedDailyData[] {
  const byDate = new Map<string, PivotedDailyData>();
  for (const row of dailyTotals) {
    const dateStr = row.date.split('T')[0];
    if (!byDate.has(dateStr)) byDate.set(dateStr, { date: dateStr });
    byDate.get(dateStr)![row.metricName] = row.value;
  }
  return Array.from(byDate.values()).sort((a, b) => a.date.localeCompare(b.date));
}

export interface PivotedDeviceData {
  name: string;
  value: number;
}

export function pivotDevices(devices: DeviceBreakdown[], dimension: string): PivotedDeviceData[] {
  const grouped = new Map<string, number>();
  for (const d of devices) {
    if (d.dimension === dimension) {
      grouped.set(d.dimensionValue, (grouped.get(d.dimensionValue) || 0) + d.visitorCount);
    }
  }
  return Array.from(grouped.entries())
    .map(([name, value]) => ({ name, value }))
    .sort((a, b) => b.value - a.value);
}


export function pivotBreakdowns(breakdowns: DailyBreakdown[]): PivotedDailyData[] {
  const byDate = new Map<string, PivotedDailyData>();
  for (const row of breakdowns) {
    const dateStr = row.date.split('T')[0];
    if (!byDate.has(dateStr)) byDate.set(dateStr, { date: dateStr });
    byDate.get(dateStr)![row.breakdownValue] = row.value;
  }
  return Array.from(byDate.values()).sort((a, b) => a.date.localeCompare(b.date));
}
